<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div class="search-form btn-2b5a95">
      <div
        class="l-w"
        :style="{
          height: $store.state.global.isSearchExtend_1
            ? ''
            : $store.state.global.searchFormHeight_1 + 10 + 'px',
        }"
      >
        <el-form
          label-position="right"
          :class="
            $store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'
          "
					@submit.native.prevent
					:model="searchForm"
        >
          <el-form-item label="标题:">
            <el-input 
							v-model.trim="searchForm.title"
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>
					<el-form-item label="收款方:">
					  <el-input 
							v-model.trim="searchForm.unitname" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>
					<el-form-item label="应付总额:">
					  <el-input 
							v-model.trim="searchForm.total" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>     
					<el-form-item label="付款标识:">
						<el-select 
							v-model="searchForm.isokflag"
							@keyup.enter.native="seach"
							@visible-change="visibleType"
							ref="selectref"
							clearable>
							<el-option value="0" label="未付"></el-option>
							<el-option value="1" label="已付"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="出纳审核:">
						<el-select 
							v-model="searchForm.approveflag" 
							@keyup.enter.native="seach"
							@visible-change="visibleApprove"
							ref="approref"
							clearable>
							<el-option value="-1" label="审核中"></el-option>
							<el-option value="0" label="不通过"></el-option>
							<el-option value="1" label="通过"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="负责人审核:">
						<el-select 
							v-model="searchForm.approveflag2"
							@keyup.enter.native="seach"
							@visible-change="approverflag"
							ref="approverflagRef"
							clearable>
							<el-option value="-1" label="审核中"></el-option>
							<el-option value="0" label="不通过"></el-option>
							<el-option value="1" label="通过"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="教学点:">
					  <el-input 
							v-model.trim="searchForm.schoolorgname" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>
        </el-form>
      </div>
      <div class="r-w">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="seach"
          :loading="!$store.state.global.isEndRequest"
          class="btn-2b5a95"
          >搜索</el-button
        >
				<el-button typr="primary" @click="resetQuery">重置</el-button>
        <el-button
          type="primary"
          :icon="
            $store.state.global.isSearchExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          v-if="$store.state.global.searchExtend_1"
          class="btn-2b5a95"
          @click="onExtendClick('isSearchExtend_1')"
          >{{ $store.state.global.searchExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      stripe
			border
			:header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="标题" prop="title" align="center" width="200px"/>
      <el-table-column label="付款方" prop="schoolorgname" align="center" />
      <el-table-column label="收款方" prop="unitname" align="center" />
			<el-table-column label="应付总额" prop="total" align="center" />
			<el-table-column label="实付总额" prop="total2" align="center" />
			<el-table-column label="标识" align="center" prop="isokflag">
				<template slot-scope="scope">
				  {{ isokflag[scope.row.isokflag] }}
				</template>
			</el-table-column>
			<el-table-column label="出纳审核" prop="approveflag" align="center" :formatter="approveflagSate"/>
			<el-table-column label="负责人审核" prop="approveflag2" align="center" width="100px" :formatter="approveflag2Sate"/>
      <el-table-column label="录入人" prop="insertusername" align="center"  width="100px" />
			<el-table-column label="教学点" prop="schoolorgname" align="center" />
      <el-table-column label="操作" align="center" width="250">
        <template slot-scope="scope" align="center">
          <el-button type="primary" size="mini" @click="btnShow(scope.row)"
            >查看名单</el-button
          >
          <el-button type="primary" size="mini" @click="btnExport(scope.row)"
            >导出</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!-- 查看名单列表 -->
    <el-dialog
      class="btn-2b5a95"
      title="名单列表："
			v-dialogDrag
			:close-on-click-modal='false'
      :visible.sync="showDetailList"
      v-if="showDetailList"
      append-to-body
      width="80%"
			:fullscreen="$store.state.global.isFullscreen"
    >
			<span slot="title" class="el-dialog__title">
				<span>名单列表：</span>
				<span
					:class="
						$store.state.global.isFullscreen
							? 'el-icon-copy-document'
							: 'el-icon-full-screen'
					"
					@click="isExpand($store.state.global.isFullscreen)"
				></span>
			</span>
      <div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="index_2_searchFrom"
						@submit.native.prevent
          >
            <el-form-item label="流水号:" prop="id">
              <el-input 
								v-model.trim="index_2_searchFrom.id" 
								@keyup.enter.native="detailList"
								clearable />
            </el-form-item>
            <el-form-item label="姓名:" prop="studentname">
              <el-input 
								v-model.trim="index_2_searchFrom.studentname" 
								@keyup.enter.native="detailList"
								clearable />
            </el-form-item>
            <el-form-item label="身份证:" prop="idcard">
              <el-input 
								v-model.trim="index_2_searchFrom.idcard" 
								@keyup.enter.native="detailList"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="detailList"
            >搜索</el-button
          >
					<el-button type="primary" @click="queryOnSelectData">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>
      <el-table
        :data="detailRes.list"
        stripe
				:key="key"	
        border
        :header-cell-style="{ background: '#044d8c', color: '#fff'}"
        ref="multipleTable"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="流水号" prop="id" align="center" />
        <el-table-column label="学生姓名" prop="studentname" align="center" />
        <el-table-column label="性别" prop="sex" align="center" />
        <el-table-column label="身份证" prop="idcard" align="center" />
        <el-table-column label="专业" prop="major" align="center">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.major"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="层次" prop="levelval" align="center" />
        <el-table-column label="专业类别" prop="typeval" align="center" />
        <el-table-column label="学习形式" prop="studyval" align="center" />

        <el-table-column label="院校学费" prop="tuition" align="center">
          <template slot-scope="scope">
            <el-input
              v-model.trim="scope.row.tuition"
              :disabled="itemRow.flag === 4 || itemRow.flag === 6 || itemRow.flag === 9"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="总部管理费" prop="managementfee" align="center">
          <template slot-scope="scope">
            <el-input
              v-model.trim="scope.row.managementfee"
              :disabled="
                itemRow.flag === 3 || itemRow.flag === 4 || itemRow.flag === 6 
              "
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="函授站返还款" prop="refund" align="center">
          <template slot-scope="scope">
            <el-input
              v-model.trim="scope.row.refund"
              :disabled="
                itemRow.flag === 3 ||
                itemRow.flag === 6 || 
								itemRow.flag === 9
              "
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="税费" prop="taxation" align="center">
          <template slot-scope="scope">
            <el-input
              v-model.trim="scope.row.taxation"
              :disabled="
                itemRow.flag === 3 || itemRow.flag === 6 || itemRow.flag === 9
              "
            ></el-input>
          </template>
        </el-table-column>
				<el-table-column :label="otherfeename1" prop="otherfee1" align="center">
					<template slot-scope="scope">
					  <el-input
					    v-model.trim="scope.row.otherfee1"
							 :disabled="
							   itemRow.flag === 4 || itemRow.flag === 9
							 "
					  ></el-input>
					</template>
				</el-table-column>
				<el-table-column :label="otherfeename2" prop="otherfee2" align="center">
					<template slot-scope="scope">
					  <el-input
					    v-model.trim="scope.row.otherfee2"
							:disabled="
							 itemRow.flag === 4 || itemRow.flag === 9
							"
					  ></el-input>
					</template>
				</el-table-column>
				<el-table-column :label="otherfeename3" prop="otherfee3" align="center">
					<template slot-scope="scope">
					  <el-input
					    v-model.trim="scope.row.otherfee3"
							:disabled="
							  itemRow.flag === 4 || itemRow.flag === 9
							"
					  ></el-input>
					</template>
				</el-table-column>

        <el-table-column label="备注" prop="remark" align="center">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.remark"
              placeholder="请选择"
              clearable
            >
              <el-option label="不注册" value="不注册"></el-option>
              <el-option label="欠费" value="欠费"></el-option>
              <el-option label="退学" value="退学"></el-option>
              <el-option label="休学" value="休学"></el-option>
              <el-option label="转专业" value="转专业"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="教学点" prop="schoolorgname" align="center" />
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="scope" align="center">
            <el-button
              type="primary"
              size="mini"
              @click="onDetailSave(scope.row)"
              >保存</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 查看名单 - 付款 -->
    <el-dialog
      class="btn-2b5a95"
      width="900px"
			v-dialogDrag
      :title="dialogTitle"
			:close-on-click-modal='false'
      :visible.sync="showDetailPay"
      v-if="showDetailPay"
      append-to-body
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="150px"
        class="demo-dynamic form-item-w-50"
        status-icon
        :rules="rules"
      >
        <el-form-item prop="companyorgname" label="所属分公司">
          <el-select
            v-model="dynamicValidateForm.companyorgname"
            placeholder="请选择"
            :disabled="!$store.state.login.isMaxAuth"
            clearable
            @change="onChangeCompany($event, 'dynamicValidateForm')"
          >
            <el-option
              v-for="item in $store.state.selectData.companyList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="schoolorgname" label="所属教学点">
          <el-select
            v-model="dynamicValidateForm.schoolorgname"
            placeholder="请选择"
            clearable
            @change="onChangeSchool($event, 'dynamicValidateForm')"
          >
            <el-option
              v-for="item in $store.state.selectData.schoolList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="total" label="应收总金额：">
          <el-input v-model="dynamicValidateForm.total" clearable disabled></el-input>
        </el-form-item>
        <el-form-item prop="total2" label="实收总金额：">
          <el-input 
        		v-model.trim="dynamicValidateForm.total2"
        		clearable
        		:placeholder="dynamicValidateForm.total"
        	></el-input>
        </el-form-item>

        <el-form-item label="银行/现金：" prop="bankorcash">
          <el-input
            v-model="bankorcash[dynamicValidateForm.bankorcash]"
            disabled
          />
          <el-button
            type="primary"
            class="select-btn"
            @click="
              onSelectData(
							account_dialogresult,
							'showAccountModal', 
							{
                schoolorgid: dynamicValidateForm.schoolorgid,
              }
							)
            "
            >选择账户</el-button
          >
        </el-form-item>
        <el-form-item label="账户：" prop="accountname">
          <el-input v-model.trim="dynamicValidateForm.accountname" disabled />
        </el-form-item>
        <el-form-item label="卡号：" prop="cardno">
          <el-input v-model.trim="dynamicValidateForm.cardno" disabled />
        </el-form-item>
        <el-form-item label="报销人名称：" prop="outusername">
          <el-input v-model="dynamicValidateForm.outusername" disabled />
          <el-button
            type="primary"
            class="select-btn"
            @click="
              onSelectData(
							user_dialogresult,
							'showUserModal',
							)
            "
            >选择</el-button
          >
        </el-form-item>
        <el-form-item label="报销时间：" prop="outtime">
          <el-date-picker
            v-model="dynamicValidateForm.outtime"
            type="datetime"
            value-format="yyyy-MM-dd hh:mm:ss"
            placeholder="请选择"
          />
        </el-form-item>

        <el-form-item label="支出二级项目名称：" prop="type2name">
          <el-input v-model="dynamicValidateForm.type2name" disabled></el-input>
          <el-button
            type="primary"
            @click="
              onSelectData(moneyouttype2_dialogresult, 'showMoneyinitemModal2')
            "
            class="select-btn"
            >选择</el-button
          >
        </el-form-item>
        <el-form-item label="支出明细名称：" prop="itemname">
          <el-input v-model="dynamicValidateForm.itemname" disabled></el-input>
          <el-button
            type="primary"
            @click="
              onSelectData(moneyoutitem_dialogresult, 'showMoneyinitemModal')
            "
            class="select-btn"
            >选择</el-button
          >
        </el-form-item>

        <el-form-item prop="remark" label="付款备注：">
          <el-input v-model.trim="dynamicValidateForm.remark" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="onSubmitDetailPay('dynamicValidateForm')"
          :loading="!$store.state.global.isEndRequest"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 选择支出二级明细 表格 -->
    <el-dialog
      class="btn-2b5a95"
      width="1200px"
			v-dialogDrag
			:close-on-click-modal='false'
      @close="onCloseSelect"
      title="选择支出二级明细："
      :visible.sync="showMoneyinitemModal2"
      v-if="showMoneyinitemModal2"
      append-to-body
    >
      <el-button type="primary" @click="onConfirmMoneyinitem2">确定</el-button>
      <div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="支出类型:" prop="typename">
              <el-input 
								v-model.trim="selectSearchForm.typename" 
								@keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )"
								clearable />
            </el-form-item>
            <el-form-item label="支出一级项目:" prop="type1name">
              <el-input 
								v-model.trim="selectSearchForm.type1name" 
								@keyup.enter.native="onSelectSearchClick(
								  selectTableUrl,
								  null,
								  Object.assign({}, selectSearchForm)
								)"
								clearable />
            </el-form-item>
            <el-form-item label="支出二级项目:" prop="name">
              <el-input 
								v-model.trim="selectSearchForm.collegename"
								@keyup.enter.native="onSelectSearchClick(
								  selectTableUrl,
								  null,
								  Object.assign({}, selectSearchForm)
								)"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )
            "
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
					<el-button
					  type="primary"
					  :icon="
					    $store.state.global.isSearchExtend_2
					      ? 'el-icon-arrow-up'
					      : 'el-icon-arrow-down'
					  "
					  v-if="$store.state.global.searchExtend_2"
					  class="btn-2b5a95"
					  @click="onExtendClick('isSearchExtend_2')"
					  >{{ $store.state.global.searchExtendText_2 }}</el-button
					>
        </div>
      </div>
      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				stripe
				border
				:key="key"	
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          label="流水号"
          prop="id"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          label="所属支出类型名称"
          prop="typename"
          align="center"
        ></el-table-column>
        <el-table-column
          label="所属一级项目名称"
          prop="type1name"
          align="center"
        ></el-table-column>
        <el-table-column
          label="二级项目名称"
          prop="collegename"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="
          (val, data) =>
            handleSelectChange(val, Object.assign({}, selectSearchForm))
        "
        :current-page="pageinfo.pageindex"
        :page-size="pageinfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="selectTable.totalcount"
      ></el-pagination>
    </el-dialog>
    <!-- 选择支出明细 表格 -->
    <el-dialog
      class="btn-2b5a95"
      width="50%"
			v-dialogDrag
      @close="onCloseSelect"
			:close-on-click-modal='false'
      title="选择支出明细："
      :visible.sync="showMoneyinitemModal"
      v-if="showMoneyinitemModal"
      append-to-body
    >
      <el-button type="primary" @click="onConfirmMoneyinitem">确定</el-button>
      <div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="名称:" prop="name">
              <el-input 
								v-model.trim="selectSearchForm.name" 
								@keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )
            "
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>
      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				stripe
				:key="key"	
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          label="流水号"
          prop="id"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          label="名称"
          prop="name"
          align="center"
          width="100"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="
          (val, data) =>
            handleSelectChange(val, Object.assign({}, selectSearchForm))
        "
        :current-page="pageinfo.pageindex"
        :page-size="pageinfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="selectTable.totalcount"
      ></el-pagination>
    </el-dialog>
    <!-- 选择账户 -->
    <el-dialog
      class="btn-2b5a95"
      width="80%"
			v-dialogDrag
			:close-on-click-modal='false'
      @close="onCloseSelect"
      title="选择账户："
      :visible.sync="showAccountModal"
      v-if="showAccountModal"
      append-to-body
    >
      <el-button type="primary" @click="onConfirmAccount">确定</el-button>

      <div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="开户名称:" prop="accountname">
              <el-input 
								v-model.trim="selectSearchForm.accountname" 
								@keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )
            "
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>

      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				stripe
				:key="key"	
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column
          label="流水号"
          prop="id"
          align="center"
          width="200px"
        />
        <el-table-column
          label="开户名称"
          prop="accountname"
          align="center"
          width="250px"
        />
        <el-table-column
          label="余额"
          prop="curmoney"
          align="center"
          width="200px"
        />
        <el-table-column label="现金/银行" align="center" width="100px">
          <template slot-scope="scope">
            {{ bankorcash[scope.row.bankorcash] }}
          </template>
        </el-table-column>
        <el-table-column
          label="卡号"
          prop="cardno"
          align="center"
          width="200px"
        />
        <el-table-column
          label="所属教学点"
          prop="schoolorgname"
          align="center"
          width="200px"
        />
      </el-table>
      <el-pagination
        background
        @current-change="
          (val, data) =>
            handleSelectChange(
              val,
              Object.assign(
                { schoolorgid: dynamicValidateForm.schoolorgid },
                selectSearchForm
              )
            )
        "
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="selectTable.totalcount"
      ></el-pagination>
    </el-dialog>
    <!-- 选择报销人 -->
    <el-dialog
      class="btn-2b5a95"
      width="50%"
			v-dialogDrag
			:close-on-click-modal='false'
      @close="onCloseSelect"
      title="选择报销人："
      :visible.sync="showUserModal"
      v-if="showUserModal"
      append-to-body
    >
      <el-button type="primary" @click="onConfirmUser">确定</el-button>
      <div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="真实姓名:" prop="realname">
              <el-input 
								v-model.trim="selectSearchForm.realname" 
								@keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )
            "
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>
      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				stripe
				:key="key"	
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="流水号" prop="id" align="center" width="150" />
        <el-table-column
          label="真实姓名"
          prop="realname"
          align="center"
          width="150"
        />
        <el-table-column
          label="岗位"
          prop="positionname"
          align="center"
          width="150"
        />
        <el-table-column
          label="所属教学点名称"
          prop="schoolorgname"
          align="center"
          width="150"
        />
      </el-table>
      <el-pagination
        background
        @current-change="
          (val, data) =>
            handleSelectChange(
              val,
              Object.assign({}, selectSearchForm)
            )
        "
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="
         selectTable.totalcount
        "
      ></el-pagination>
    </el-dialog>

    <!-- 审批 -->
    <el-dialog
      class="btn-2b5a95"
      width="700px"
			v-dialogDrag
			:close-on-click-modal='false'
      title="审批:"
      :visible.sync="showApproval"
      v-if="showApproval"
      append-to-body
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="150px"
        class="demo-dynamic form-item-w-100"
        status-icon
        :rules="rules"
      >
        <el-form-item prop="passflag" label="审核是否通过：">
          <el-select
            v-model="dynamicValidateForm.passflag"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in approveflags"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="approvedesc" label="审核意见：">
          <el-input
            type="textarea"
            v-model.trim="dynamicValidateForm.approvedesc"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="onSubmitApproval('dynamicValidateForm')"
          :loading="!$store.state.global.isEndRequest"
          >提交
        </el-button>
      </span>
    </el-dialog>
		<!-- 审批 -->
		<el-dialog
		  class="btn-2b5a95"
		  width="700px"
			v-dialogDrag
		  title="负责人审核:"
			:close-on-click-modal='false'
		  :visible.sync="showApproval2"
		  v-if="showApproval2"
		  append-to-body
		>
		  <el-form
		    :model="dynamicValidateForm"
		    ref="dynamicValidateForm"
		    label-width="150px"
		    class="demo-dynamic form-item-w-100"
		    status-icon
		    :rules="rules"
		  >
		    <el-form-item prop="passflag" label="审核是否通过：">
		      <el-select
		        v-model="dynamicValidateForm.passflag"
		        placeholder="请选择"
		        clearable
		      >
		        <el-option
		          v-for="item in approveflags"
		          :key="item.value"
		          :label="item.label"
		          :value="item.value"
		        >
		        </el-option>
		      </el-select>
		    </el-form-item>
		
		    <el-form-item prop="approvedesc" label="审核意见：">
		      <el-input
		        type="textarea"
		        v-model.trim="dynamicValidateForm.approvedesc"
		      ></el-input>
		    </el-form-item>
		  </el-form>
		
		  <span slot="footer" class="dialog-footer">
		    <el-button
		      type="primary"
		      @click="onSubmitApproval2('dynamicValidateForm')"
		      :loading="!$store.state.global.isEndRequest"
		      >提交
		    </el-button>
		  </span>
		</el-dialog>
	<!-- 	导入应收返还款 -->
		<el-dialog
		  class="btn-2b5a95"
		  title="导入应收返还款："
			v-dialogDrag
		  :visible.sync="showImport2"
		  v-if="showImport2"
			:close-on-click-modal='false'
		  append-to-body
		  width="500px"
		>
		  <el-form
		    :model="dynamicValidateForm"
		    ref="dynamicValidateForm"
		    label-width="100px"
		    class="demo-dynamic form-item-w-100"
		    status-icon
		    :rules="rules"
		  >
				<el-form-item label="标题" prop="title">
					<el-input v-model.trim="dynamicValidateForm.title" clearable/>
				</el-form-item>
		    <el-form-item label="函授站:" prop="station">
		      <el-select
		        v-model="dynamicValidateForm.station"
		        placeholder="请选择"
		        clearable
		      >
		        <el-option
		          v-for="item in stations"
		          :key="item.key"
		          :label="item.val"
		          :value="item.val"
		        >
		        </el-option>
		      </el-select>
		    </el-form-item>
		
		    <el-form-item>
		      <el-upload
		        class="upload-demo"
		        name="file"
		        ref="upload"
		        action=""
		        accept=".xls, .xlsx"
		        :on-change="handleChange"
		        :fileList="fileList"
		      >
		        <el-button slot="trigger" type="primary">选择文件</el-button>
		
		        <el-button
		          class="select-btn"
		          type="success"
		          @click="
		            downloadTemp('download/财务管理/院校往来学生名单导入模板.xls')
		          "
		          >下载模板</el-button
		        >
		        <div slot="tip" class="el-upload__tip" v-if="!resTipC">
		          只能上传以.xls为后缀的文件
		        </div>
		        <!-- 响应提示 -->
		        <div v-else>
		          <h2>提示：</h2>
		          <div v-html="resTipC" class="resTipc-w" style="color: red;"></div>
		        </div>
		      </el-upload>
		    </el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="onSubmitImport2('dynamicValidateForm')"
		      >提交</el-button
		    >
		  </span>
		</el-dialog>
  </div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";

import {
	collegesreceivable_importance,
  collegespay_list,
  collegespay_input,
  collegespaydetail_list,
  collegespay_exportdetail,
  collegespaydetail_save2,
  collegespaydetail_pay,
  collegespaydetail_paysave,
  collegespayfee_list,
	collegespay_pay,
	conllespay_paysave,
  collegespay_approvecheck,
  collegespay_approvesave,
} from "@/request/api/allChildrenProject";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";
import {
  _projectTypes,
  _available,
  _availables,
  _approveflag,
  _bankorcash,
  _payType,
  _payTypes,
} from "@/assets/js/filedValueFlag";
import {
  _filedownload_save,
  _moneyoutitem_dialogresult,
  _moneyouttype2_dialogresult,
  _account_dialogresult,
  _user_dialogresult,
} from "@/request/api/public";

export default {
  mixins: [part],
  name: "collegesreceivable",
  components: {},
  props: {
    projectTypes: {
      default: () => _projectTypes,
    },
    available: {
      default: () => _available,
    },
    availables: {
      default: () => _availables,
    },
    account_dialogresult: {
      default: () => _account_dialogresult,
    },
    approveflag: {
      default: () => _approveflag,
    },
    moneyoutitem_dialogresult: {
      default: () => _moneyoutitem_dialogresult,
    },
    moneyouttype2_dialogresult: {
      default: () => _moneyouttype2_dialogresult,
    },
    bankorcash: {
      default: () => _bankorcash,
    },
    user_dialogresult: {
      default: () => _user_dialogresult,
    },
    payType: {
      default: () => _payType,
    },
    payTypes: {
      default: () => _payTypes,
    },
  },
  inject: ["reload"],
  data() {
    return {
			isokflag: {
				0 :'未付',
				1 : '已付'
			},
			showImport2: false,
      itemRow: null, //表格项
      searchForm: {},
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, //显示表单框
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, //表单
      rules: {
				title: [{ trigger: "blur", message: "必填字段", required: true }],
        station: [{ trigger: "blur", message: "必填字段", required: true }],

        companyorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        schoolorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        tuition3: [{ trigger: "blur", message: "必填字段", required: true }],
        managementfee3: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        refund3: [{ trigger: "blur", message: "必填字段", required: true }],
        taxation3: [{ trigger: "blur", message: "必填字段", required: true }],
        course3: [{ trigger: "blur", message: "必填字段", required: true }],
        task3: [{ trigger: "blur", message: "必填字段", required: true }],
        platform3: [{ trigger: "blur", message: "必填字段", required: true }],
        total: [{ trigger: "blur", message: "必填字段", required: true }],
        total2: [{ trigger: "blur", message: "必填字段", required: true }],
        bankorcash: [{ trigger: "blur", message: "必填字段", required: true }],
        accountname: [{ trigger: "blur", message: "必填字段", required: true }],
        outusername: [{ trigger: "blur", message: "必填字段", required: true }],
        outtime: [{ trigger: "blur", message: "必填字段", required: true }],
        type2name: [{ trigger: "blur", message: "必填字段", required: true }],
        itemname: [{ trigger: "blur", message: "必填字段", required: true }],
        remark: [{ trigger: "blur", message: "必填字段", required: true }],

        passflag: [{ trigger: "blur", message: "必填字段", required: true }],
        approvedesc: [{ trigger: "blur", message: "必填字段", required: true }],
      }, //表单规则

      showDetailModal: false,
      showImport: false,
      fileList: [], //上传的文件列表，仅作展示
      file: new FormData(),
      resTipC: "", //响应提示 object
			key: '',
      stations: [], //函授站
      showDetailList: false,
      detailRes: {},
      index_2_searchFrom: {},

      showDetailPay: false, //查看名单 - 付款

      selectTable: {},
      selectTableUrl: null,
      selectPageInfo: {
        pageindex: 1,
        pagesize: 10,
      },
      selectSearchForm: {},

      showMoneyinitemModal2: false, //支出二级明细框
      showMoneyinitemModal: false, //支出明细框
      showAccountModal: false, //账户
      showUserModal: false, //报销人
      showApproval: false, //审批
			showApproval2:false,
      approveflags: [
        {
          value: "0",
          label: "不通过",
        },
        {
          value: "1",
          label: "通过",
        },
      ],
    };
  },
  created() {
    this.getDataList();
    this.dic_combox({
      that: this,
      list: "stations",
      typecode: "station",
    });
    this.org_combox();
    this.org_comboxchild(this.dynamicValidateForm.companyorgid);
		window.addEventListener("keyup", this.enterSelect);
  },
  methods: {
    ...mapActions("global", ["onExtendClick", "isExpand"]),
    ...mapActions("selectData", [
      "dic_combox",
      "org_comboxchild",
      "org_combox",
    ]),
		enterSelect(e) {
			if(e.keyCode == 13) {
				this.getDataList();
			}
		},
		visibleType(e) {
			if(!e) {
				this.$refs.selectref.blur();
			}
		},
		visibleApprove(e) {
			if(!e) {
				this.$refs.approref.blur();
			}
		},
		approverflag(e) {
			if(!e) {
				this.$refs.approverflagRef.blur();
			}
		},
		reset() {
			this.searchForm = {
				title: null,
				unitname: null,
				total: null,
				isokflag: null,
				approveflag: null,
				approveflag2: null,
				schoolorgname: null,
				accountname: null,
			}
		},
		//重置
		resetQuery() {
			this.reset();
			this.getDataList();
		},
		selectQuery() {
			this.selectSearchForm = {
				realname: null,
				typename: null,
				type1name: null,
				name: null,
			}
		},	
		query() {
			this.index_2_searchFrom = {
				id: null,
				studentname: null,
				idcard: null,
				idcard: null
			}
		},	
		queryOnSelectData() {
			this.query();
			this.detailList();
		},
		handleQuery() {
			this.selectQuery();
			this.onSelectData(this.selectTableUrl, null, null);
		},
		//改变分公司 change
		onChangeCompany(val, form) {
		  //this[form].schoolorgname = "";
		  this[form].companyorgid = val;
		  this.org_comboxchild(val);
		},
		onChangeSchool(val, form) {
		  this[form].schoolorgid = val;
			this.org_comboxchild(val);
		},
		approveflagSate(row, column) {
			if(row.approveflag === -1){
				return '审核中'
			}else if(row.approveflag === 0 ){
				return '不通过'
			}else if(row.approveflag === 1){
				return '通过'
			}else if( row.approveflag === -2){
				return '未提醒审核'
			}
		},
		approveflag2Sate(row, column) {
			if(row.approveflag2 === -1){
				return '审核中'
			}else if(row.approveflag2 === 0 ){
				return '不通过'
			}else if(row.approveflag2 === 1){
				return '通过'
			}else if( row.approveflag2 === -2){
				return '未提醒审核'
			}
		},
    //上传文件改变时
    handleChange(file, fileList) {
      this.file = new FormData();
      this.file.append("scorefile", file.raw);
      this.fileList = [{ name: file.name, url: file.name }];
    },
    //下载模板 click
    downloadTemp(url) {
      myRequest({
        url: _filedownload_save,
        data: {
          fileurl: url,
        },
      }).then((res) => {
        if (res.status === 200) {
          location.href =
            this.$url.Freemarker + _filedownload_save + "?fileurl=" + url;
        }
      });
    },

    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: collegespay_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    //刷新 click
    btnReload() {
      this.getDataList();
    },
    //导出 click
    btnExport(row) {
      window.location.href =
        this.$url.Freemarker + collegespay_exportdetail + "?id=" + row.id;
    },
		//导入返还款 click
		btnImport(){
			this.dynamicValidateForm = {
			  station: "",
				title: ""
			};
			this.file.delete("scorefile");
			this.fileList = [];
			this.showImport2 = true;
		},
		//导入 - 提交 api
		onSubmitImport2(formName) {
		  this.$refs[formName].validate((valid) => {
		    if (valid) {
		      this.file.append("station", this.dynamicValidateForm.station);
					this.file.append("title", this.dynamicValidateForm.title);
		      if (!this.file.get("scorefile")) {
		        return messageTip({
		          message: "请选择需要导入的文件",
		          type: "warning",
		        });
		      }
		      myRequest({
		          method: "post",
		          url: collegesreceivable_importance,
		          data:this.file,
		          headers: {
		            "Content-Type": "multipart/form-data",
		          },
		        }).then((res) => {
							this.resTipC = res.data.data;
							if(res.data.code === "200") {
								this.getDataList();
								this.showImport2 = false;
							}
						})
		    }
		  });
		},
    //审批 click
    btnApproval() {
      selectCheck(this.multipleSelection, "操作", true, () => {
        this.approvecheck(this.multipleSelection.map((i) => i.id));
      });
    },
		//负责人审批 click
		btnApproval2() {
			 selectCheck(this.multipleSelection, "操作", true, () => {
			this.ids = this.multipleSelection.map((i) => i.id);
			this.dynamicValidateForm.flag = 2;
			if(this.multipleSelection[0].approveflag2 !== 1){
				this.dynamicValidateForm = {};
				this.showApproval2 = true;
				this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
			} else {
				this.$message({
					type: "warning",
					message: "已审批, 无需再审",
				})
			}
		 });	
		},
		//负责人审批 api
		 onSubmitApproval2(dynamicValidateForm) {
			this.$refs[dynamicValidateForm].validate((vaild) => {
				if(vaild) {
					myRequest(
						{
							method:"post",
							url: collegespay_approvesave,
							data: this.$qs.stringify(
								{
									ids: this.ids,
									passflag: this.dynamicValidateForm.passflag,
									approvedesc: this.dynamicValidateForm.approvedesc,
									flag: 2
								},
								{
								  arrayFormat: "repeat",
								}
							)
						},
						{
						  isRefTableList: true,
						  that: this,
						  modal: "showApproval2",
						}
					)
				}
			})
		},
    //审批检查 api
    approvecheck(ids) {
      myRequest({
        method: "post",
        url: collegespay_approvecheck,
        data: this.$qs.stringify(
          {
            ids: ids,
						flag: 1
          },
          {
            arrayFormat: "repeat",
          }
        ),
      }).then((res) => {
        if (res.data.code === "200") {
          this.showApproval = true;
          this.dynamicValidateForm.ids = ids;
					this.dynamicValidateForm.flag = 1;
        }
      });
    },
    //审批保存 api
    onSubmitApproval(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myRequest(
            {
              method: "post",
              url: collegespay_approvesave,
              data: this.$qs.stringify(this.dynamicValidateForm, {
                arrayFormat: "repeat",
              }),
            },
            {
              that: this,
              modal: "showApproval",
              isRefTableList: true,
            }
          );
        }
      });
    },
    //查看名单 click
    btnShow(row) {
      this.itemRow = row;
      this.detailList();
    },
    //查看名单 api
    detailList() {
      myRequest({
        url: collegespaydetail_list,
        data: Object.assign(
          {
            collegespayid: this.itemRow.id,
          },
          this.index_2_searchFrom
        ),
      }).then((res) => {
        if (res.data.code === "200") {
          this.detailRes = res.data.data;
          this.multipleSelection = [];
          this.showDetailList = true;
					this.otherfeename1 = res.data.data.list[0].otherfeename1;
					this.otherfeename2 = res.data.data.list[0].otherfeename2;
					this.otherfeename3 = res.data.data.list[0].otherfeename3;
        }
      });
    },
    //查看名单 - 保存 click
    onDetailSave(row) {
      if (!row.remark)
        return messageTip({ message: "请选择备注类型", type: "warning" });
      myRequest({
        url: collegespaydetail_save2,
        data: row,
      }).then((res) => {
        if (res.data.code === "200") {
          this.detailList();
        }
      });
    },
    //查看名单 - 付款 click
		btnPay() {
			this.dialogTitle = "付款";
			selectCheck(this.multipleSelection, "操作", false, () => {
				this.detailPayRoute(this.multipleSelection[0].id);
				this.dynamicValidateForm.id = this.multipleSelection[0].id;
				this.dynamicValidateForm.companyorgname= this.multipleSelection[0].companyorgname;
				this.dynamicValidateForm.schoolorgname = this.multipleSelection[0].schoolorgname;
				this.dynamicValidateForm.total = this.multipleSelection[0].total;
			});
		},
    // 付款路由 api
    detailPayRoute(id) {
      myRequest({
        url: collegespay_pay,
        data: {
					id: id,
						},
      }).then((res) => {
        if (res.data.code === "200") {
          this.showDetailPay = true;
				this.dynamicValidateForm.schoolorgid = res.data.data.vcollegespay.schoolorgid;
        }
      });
    },
    //查看名单 - 付款保存 api
    onSubmitDetailPay(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myRequest({
            method: "post",
            url: conllespay_paysave,
            data: this.$qs.stringify(this.dynamicValidateForm, {
              arrayFormat: "repeat",
            }),
          }).then((res) => {
            if (res.data.code === "200") {
              this.showDetailPay = false;
            }
          });
        }
      });
    },

    //确认支出二级明细 click
    onConfirmMoneyinitem2() {
      selectCheck(this.multipleSelection, "确认支出二级明细", false, () => {
        this.$set(
          this.dynamicValidateForm,
          "type2name",
          this.multipleSelection[0].collegename
        );
        this.$set(
          this.dynamicValidateForm,
          "typename",
          this.multipleSelection[0].typename
        );
        this.$set(
          this.dynamicValidateForm,
          "type1name",
          this.multipleSelection[0].type1name
        );
        this.dynamicValidateForm.typeid = this.multipleSelection[0].typeid;
        this.dynamicValidateForm.type1id = this.multipleSelection[0].type1id;
        this.dynamicValidateForm.type2id = this.multipleSelection[0].id;
        this.showMoneyinitemModal2 = false;
				this.multipleSelection = [];
				this.selectQuery();
      });
    },
    //确认支出明细 click
    onConfirmMoneyinitem() {
      selectCheck(this.multipleSelection, "确认支出明细", false, () => {
        this.$set(
          this.dynamicValidateForm,
          "itemname",
          this.multipleSelection[0].name
        );
        this.dynamicValidateForm.itemid = this.multipleSelection[0].id;
        this.showMoneyinitemModal = false;
				this.multipleSelection = [];
				this.selectQuery();
      });
    },
    //确认账户 click
    onConfirmAccount() {
      selectCheck(this.multipleSelection, "确认账户", false, () => {
        this.$set(
          this.dynamicValidateForm,
          "bankorcash",
          this.multipleSelection[0].bankorcash
        );
        this.$set(
          this.dynamicValidateForm,
          "accountname",
          this.multipleSelection[0].accountname
        );
        this.$set(
          this.dynamicValidateForm,
          "cardno",
          this.multipleSelection[0].cardno
        );
        this.dynamicValidateForm.accountid = this.multipleSelection[0].id;
        this.showAccountModal = false;
				this.multipleSelection = [];
				this.selectQuery();
      });
    },
    //确认报销人 click
    onConfirmUser() {
      selectCheck(this.multipleSelection, "确认报销人", false, () => {
        this.$set(
          this.dynamicValidateForm,
          "outusername",
          this.multipleSelection[0].realname
        );
        this.dynamicValidateForm.outuserid = this.multipleSelection[0].id;
        this.showUserModal = false;
				this.selectQuery();
				this.multipleSelection = [];
      });
    },

    //切换选项表格页
    handleSelectChange(val, data) {
      this.selectPageInfo.pageindex = val;
      this.onSelectData(this.selectTableUrl, null, data);
    },
    //选项表格 api
    onSelectData(url, modal, data) {
      this.selectIndex = data?.index || 0;
      this.selectTableUrl = url;
      myRequest({
        url: this.selectTableUrl,
        data: Object.assign(data || {}, this.selectPageInfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
          this.selectTable = res.data.data;
					this.key = Math.random();
          this[modal] = true;
        }
      });
    },
    //选项表格 - 搜索 click
    onSelectSearchClick(url, modal, data) {
      this.selectPageInfo.pageindex = 1;
      this.onSelectData(url, modal, data);
    },
    //关闭选项框 click
    onCloseSelect() {
      this.selectPageInfo.pageindex = 1;
    },
    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style  lang="scss">
</style>